import React from 'react';
import { useContext } from 'react';
import { ProductContext } from '../App';

function ConfirmDialogue() {
    const product_context = useContext(ProductContext);
    const { confirmDialogue, setConfirmDialogue } = product_context;
    const { isOpen, data, message, submitHandle } = confirmDialogue;
    let sizes = data?.size;
    let size = '';
    sizes?.forEach(element => {
        size += `${element.toUpperCase()},`;
    });
    size = size.slice(0, -1);
    return (
        <>
            {isOpen ?
                <>
                    <div className="back">
                        <div className="dialogue-container flex-column p-3 pb-3">
                            <strong className='mb-3 mt-3'>{message}</strong>
                            {data ? <div className="w-75">
                                <p><strong>Seller Name:</strong> {data.seller_name}</p>
                                <p><strong>Item Type:</strong> {data.item_type}</p>
                                <p><strong>Item Name:</strong> {data.item_name}</p>
                                <p><strong>Price:</strong> {data.price}</p>
                                <p><strong>Additional Price:</strong> {data.additional_price}</p>
                                <p><strong>Color:</strong> {data.color}</p>
                                <p><strong>Size:</strong> {size}</p>
                            </div> : null}

                            <div className="d-flex">
                                <button type="button" className="btn btn-success me-2" onClick={() => {
                                    data ? submitHandle(data) : submitHandle();
                                    document.body.classList.remove('remove-scroll');
                                }} >Ok</button>
                                <button type="button" className='btn btn-danger ms-2' onClick={() => {
                                    setConfirmDialogue({ ...confirmDialogue, isOpen: false });
                                    document.body.classList.remove('remove-scroll');
                                }} >Close</button>
                            </div>
                        </div>
                    </div>
                </> : null}

        </>
    )
}

export default ConfirmDialogue
